import React from 'react';
import styled from 'styled-components';
import image from 'assets/img/tlo-portal-pacjenta.jpg';
import { useLocation } from 'react-router-dom';
import ROUTES from 'utils/constants/routes.json';

type Props = {
    children?: React.ReactChild | React.ReactChild[];
};

const Container = styled.div`
    flex: 1;
    background-image: url(${image});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    align-content: center;
    flex-wrap: wrap;
    overflow: auto;
    padding: 25px;
`;

const StyledContainer = styled.div`
    padding: 25px;
`;

const BackgroundImageContainer: React.FC<Props> = ({ children }: Props) => {
    const { pathname } = useLocation();

    if (
        !(
            [
                ROUTES.login_portal,
                ROUTES.login_result,
                ROUTES.reset_password,
                ROUTES.reset_password_link_sent,
                ROUTES.change_password_with_token,
                ROUTES.faq,
                ROUTES.portal_consent,
                ROUTES.portal_regulations,
                ROUTES.contact,
                ROUTES.password_changed,
                ROUTES.contact_submitted,
            ].includes(pathname) || pathname.includes('change-password/')
        )
    ) {
        return <StyledContainer>{children}</StyledContainer>;
    }

    return <Container className="background-image-container container">{children}</Container>;
};

BackgroundImageContainer.defaultProps = {
    children: <></>,
};

export default BackgroundImageContainer;
